import React from 'react';

const MYOMagicWand = ({ color = 'white', size = 16 }: { color?: string; size?: number }) => (
  <svg viewBox="0 0 16 16" width={size} height={size} fill={'none'}>
    <g clipPath="url(#clip0_27676_19890)">
      <path d="M0.65625 13.4157L6.85631 7.2156L8.77321 9.13251L2.57315 15.3326L0.65625 13.4157Z" fill={color} />
      <path d="M9.91778 4.15583L7.47009 6.60384L9.38728 8.52102L11.8352 6.07334L9.91778 4.15583Z" fill={color} />
      <path
        d="M4.96146 6.62345L6.01461 4.69784L7.94022 3.64469L6.01461 2.59153L4.96146 0.665922L3.9083 2.59153L1.98269 3.64469L3.9083 4.69784L4.96146 6.62345Z"
        fill="white"
      />
      <path
        d="M12.808 5.70034L13.6979 4.07307L15.3252 3.18313L13.6979 2.29316L12.808 0.665894L11.918 2.29316L10.2907 3.18313L11.918 4.07307L12.808 5.70034Z"
        fill="white"
      />
      <path
        d="M12.808 7.35845L11.918 8.98573L10.2907 9.87569L11.918 10.7656L12.808 12.3929L13.6979 10.7656L15.3252 9.87569L13.6979 8.98573L12.808 7.35845Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_27676_19890">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MYOMagicWand;
